import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid";
import { TABLE_NAMES } from "../../../constants";

@Component({
    selector: 'lfwms-custom-cell-renderer',
    templateUrl: './custom-cell-renderer.component.html',
    styleUrls: ['./custom-cell-renderer.component.css']
  })
  export class CustomCellRendererComponent implements ICellRendererAngularComp {
  
    public params: any;
    public cellValue: any;
    public statusIndicator: any;
    public typeTextField: string = 'TEXTFIELD';
    public statusCss = '';
    constructor() { }
  
    agInit(params: ICellRendererParams): void {
      this.init(params);
    }
    refresh(params: any): boolean {
      this.init(params);
      return true;
    }
    private init(params: any) {
      this.params = params;
      this.statusIndicator = params.value;
      if (params.cellMetaData['type'] === this.typeTextField) {
        this.cellValue = params.value['cVal'];
        this.statusCss = 'statusMBOLError';
      } else {
        const dropdownValues = params.cellMetaData.values;
        this.statusCss = this.statusIndicator === 'N' ? 'statusCellNormal' : 'statusCellShipped';
        if (params.cellMetaData['dbTableName'] === TABLE_NAMES.ORDER_DETAIL) {
          this.statusCss = '';
        }
        if (params.value && dropdownValues.length !== 0) {
          const cValue = dropdownValues.find(x => x.key === params.value.cVal);
          this.cellValue = cValue ? cValue.value : params.value.cVal;
        }
     }
    }
    public navigateToHyperlink() {
      this.params.context.componentParent.tableEditor.navigateToHyperlink(this.params);
    }
  }
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.ts